export const STATES = {
  DISABLE: 0,
  PARTIAL: 1,
  BLOCK_ALL: 2,
};

export const SESSION_KEY = 'visitorPrioitizeDetails';

export const ERROR_ACTION = 'VP/block_error';

export const VISITOR_PRIORITIZATION_FALLBACK_IMAGE =
  'https://ne-nysaa-staging-fe-static-assets.nysaa.com/images/vp.png';
